import axios from 'axios';

export default class DashboardService {
    constructor(http, store) {
        this._http = http;
        this._store = store;
        this._ctrl = store.getters.getAbortCtrl;
    }

    getQuadroInformacoes() {
        return axios.get(
            process.env.VUE_APP_RECUPERI_API + 'dashboard/quadro-informacoes',
            {
                params: {},
                headers: {
                    Authorization: 'Bearer ' + this._store.getters.token
                },
                signal: this._ctrl.signal
            }
        );
    }

    getValoresEnviados(days = 0, filterParams = null) {
        const params = {
            days: days
        };

        if (filterParams) {
            if (filterParams.nm_cedente_favorecido) {
                params.nm_cedente_favorecido =
                    filterParams.nm_cedente_favorecido;
            }
            if (filterParams.cnpj_sacador) {
                params.cnpj_sacador = filterParams.cnpj_sacador;
            }
        }

        return axios.get(
            process.env.VUE_APP_RECUPERI_API + 'dashboard/valores-enviado',
            {
                params: params,
                headers: {
                    Authorization: 'Bearer ' + this._store.getters.token
                },
                signal: this._ctrl.signal
            }
        );
    }

    getValoresRecuperados(days = 0, filterParams = null) {
        const params = {
            days: days
        };

        if (filterParams) {
            if (filterParams.nm_cedente_favorecido) {
                params.nm_cedente_favorecido =
                    filterParams.nm_cedente_favorecido;
            }
            if (filterParams.cnpj_sacador) {
                params.cnpj_sacador = filterParams.cnpj_sacador;
            }
        }

        return axios.get(
            process.env.VUE_APP_RECUPERI_API + 'dashboard/valores-recuperado',
            {
                params: params,
                headers: {
                    Authorization: 'Bearer ' + this._store.getters.token
                },
                signal: this._ctrl.signal
            }
        );
    }
}
